import { createSelector } from "@reduxjs/toolkit";

import type { RootState } from "types";

export const getKnowledgeById = (id: string | undefined) => (state: RootState) =>
  id === undefined ? undefined : state.entities.knowledge.byId[id];

const createKnowledgeSelector = (id: string) => (state: RootState) => state.entities.knowledge.byId[id];

export const createKnowledgesSelector = (ids: string[]) =>
  createSelector(...ids.map(createKnowledgeSelector), (...knowledges) => knowledges);
